<template>
	<div class="widgets-content">
		<div v-bind:class="['title-content', contentOpen ? 'open' : '']" @click="contentOpen=!contentOpen">
			<h4>
				Bloques de Contenidos
				<i class="fas fa-chevron-down" v-if="contentOpen"></i>
				<i class="fas fa-chevron-right" v-else></i>
			</h4>
		</div>
		<draggable
	        class="box-contents list-widgets"
	        :list="listSections"
	        :group="{ name: 'contents', pull: 'clone', put: false }"
	        :clone="cloneSection"
	        @change="log"
	      >
			<div class="box-section" v-for="(i, index) in listSections" :key="index">
				<svg v-if="i.id==1" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="44" height="34"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-58.000000, -283.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-13" transform="translate(0.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-4" transform="translate(8.000000, 20.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="57" y="23" width="39" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="31" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="36" width="43" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="57" y="41" width="22.5599995" height="1"></rect></g></g></g></g></svg>
				<svg v-if="i.id==2" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="44" height="26"></rect><rect id="path-2" x="0" y="0" width="44" height="34"></rect><rect id="path-3" x="0" y="0" width="44" height="34"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-174.000000, -283.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-14" transform="translate(116.000000, 47.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><rect id="Rectangle-122" fill="#9E9E9E" x="11" y="51" width="39" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="11" y="59" width="39" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="15" y="64" width="30" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="59" y="59" width="39" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="63" y="64" width="30" height="1"></rect><g id="Group-4" transform="translate(8.000000, 10.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-1"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="25"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 13.4633821 19.6563122 15.4540679 24.0304259 9 30.2857143 19 14 19"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="8.71428571" r="1.71428571"></circle></g><g id="Group-4" transform="translate(8.000000, 10.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-2"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g><g id="Group-4" transform="translate(56.000000, 10.000000)"><g id="Rectangle-122"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-3"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="43" height="33"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="17.7304061 16.4633821 19.6563122 18.4540679 24.0304259 12 30.2857143 22 14 22"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="17.4285714" cy="11.7142857" r="1.71428571"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="59" y="51" width="39" height="2"></rect></g></g></g></g></svg>
				<svg v-if="i.id==3" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M38,11 L100,11 L100,63 L38,63 L38,11 Z" id="path-1"></path><rect id="path-3" x="38" y="11" width="62" height="52"></rect><rect id="path-4" x="0" y="0" width="22" height="22"></rect><rect id="path-5" x="0" y="0" width="22" height="22"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-174.000000, -447.000000)"><g id="Group-5" transform="translate(174.000000, 447.000000)"><g id="Group-8"><g id="Group" transform="translate(60.000000, 29.000000)" fill="#757575"><polygon id="Rectangle-624" points="4.41234793 7.20876695 6.69032187 9.5318973 11.8640512 2 19.2628458 13.6700001 0 13.6700001"></polygon><circle id="Oval-10" cx="4" cy="2" r="2"></circle></g><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="38.5" y="11.5" width="61" height="51"></rect></g><g id="Group" transform="translate(60.000000, 29.000000)" fill="#757575"><polygon id="Rectangle-624" points="4.41234793 7.20876695 6.69032187 9.5318973 11.8640512 2 19.2628458 13.6700001 0 13.6700001"></polygon><circle id="Oval-10" cx="4" cy="2" r="2"></circle></g><g id="Group-21" transform="translate(8.000000, 11.000000)"><g id="Rectangle"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-4"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g><g id="Group-21" transform="translate(8.000000, 41.000000)"><g id="Rectangle"><use fill="#FDFDFD" fill-rule="evenodd" xlink:href="#path-5"></use><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g></g></g></g></g></svg>
				<svg v-if="i.id==4" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="24" height="24"></rect><rect id="path-2" x="0" y="0" width="24" height="24"></rect><rect id="path-3" x="0" y="0" width="24" height="24"></rect><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="rect-1"></path></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="winner-copy-5" transform="translate(-174.000000, -365.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-17" transform="translate(116.000000, 129.000000)"><g id="Rectangle-47"><use fill-opacity="0" fill="#FFFFFF" fill-rule="evenodd" xlink:href="#rect-1"></use></g><g id="Group-3" transform="translate(8.000000, 13.000000)"><g id="Rectangle-122"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="23" height="23"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="8.67824028 12.1243675 10.0609421 13.5178475 13.2013314 9 17.6923077 16 6 16"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="8.46153846" cy="8.23076923" r="1.23076923"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="8" y="43" width="24" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="8" y="51" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="8" y="56" width="24" height="1"></rect><g id="Group-3" transform="translate(42.000000, 13.000000)"><g id="Rectangle-122"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="23" height="23"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="8.67824028 12.1243675 10.0609421 13.5178475 13.2013314 9 17.6923077 16 6 16"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="8.46153846" cy="8.23076923" r="1.23076923"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="42" y="43" width="24" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="42" y="51" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="42" y="56" width="24" height="1"></rect><g id="Group-3" transform="translate(76.000000, 13.000000)"><g id="Rectangle-122"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="23" height="23"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="8.67824028 12.1243675 10.0609421 13.5178475 13.2013314 9 17.6923077 16 6 16"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="8.46153846" cy="8.23076923" r="1.23076923"></circle></g><rect id="Rectangle-122" fill="#9E9E9E" x="76" y="43" width="24" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="76" y="51" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="76" y="56" width="24" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="11" y="61" width="18" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="45" y="61" width="18" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="79" y="61" width="18" height="1"></rect></g></g></g></g></svg>
				<svg v-if="i.id==5" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="18" height="18"></rect><rect id="path-2" x="0" y="0" width="18" height="18"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="L-to-R" transform="translate(-58.000000, -365.000000)"><g id="Group-11" transform="translate(58.000000, 236.000000)"><g id="Group-15" transform="translate(0.000000, 129.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-21" transform="translate(8.000000, 26.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="17" height="17"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.10037841 8.28357339 8.23167991 9.42369344 10.8010893 5.72727273 14.4755245 11.4545455 4.90909091 11.4545455"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="6.73426573" cy="5.91608392" r="1.00699301"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="30" y="28" width="15" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="30" y="36" width="20" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="30" y="41" width="20" height="1"></rect><g id="Group-21" transform="translate(57.000000, 26.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="17" height="17"></rect></g><g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.10037841 8.28357339 8.23167991 9.42369344 10.8010893 5.72727273 14.4755245 11.4545455 4.90909091 11.4545455"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="6.73426573" cy="5.91608392" r="1.00699301"></circle></g></g><rect id="Rectangle-122" fill="#9E9E9E" x="80" y="28" width="15" height="2"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="80" y="36" width="20" height="1"></rect><rect id="Rectangle-122" fill="#E0E0E0" x="80" y="41" width="20" height="1"></rect></g></g></g></g></svg>
				<svg v-if="i.id==6" width="108px" height="74px" viewBox="0 0 108 74" version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="0" y="0" width="22" height="22"></rect><rect id="path-2" x="0" y="0" width="22" height="22"></rect><rect id="path-3" x="0" y="0" width="22" height="22"></rect><rect id="path-4" x="0" y="0" width="22" height="22"></rect></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="L-to-R" transform="translate(-58.000000, -447.000000)"><g id="Group-5" transform="translate(58.000000, 447.000000)"><path d="M0,0.990129262 C0,0.44329597 0.446521291,0 1.00019413,0 L106.999806,0 C107.552198,0 108,0.453369457 108,0.990129262 L108,73.0098707 C108,73.556704 107.553479,74 106.999806,74 L1.00019413,74 C0.447802166,74 0,73.5466305 0,73.0098707 L0,0.990129262 Z" id="Rectangle-47"></path><g id="Group-10" transform="translate(5.000000, 24.000000)"><g id="Group-6"><g id="Group-21"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g><g id="Group-21" transform="translate(50.000000, 0.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g><g id="Group-21" transform="translate(75.000000, 0.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g><rect id="Rectangle-2" fill="#9E9E9E" x="5" y="25" width="12" height="1"></rect><rect id="Rectangle-2" fill="#9E9E9E" x="30" y="25" width="12" height="1"></rect><rect id="Rectangle-2" fill="#9E9E9E" x="55" y="25" width="12" height="1"></rect><rect id="Rectangle-2" fill="#9E9E9E" x="80" y="25" width="12" height="1"></rect><g id="Group-21" transform="translate(25.000000, 0.000000)"><g id="Rectangle"><rect stroke-opacity="0.2" stroke="#979797" stroke-width="1" x="0.5" y="0.5" width="21" height="21"></rect></g><polygon id="Rectangle-624" fill="#666666" fill-rule="evenodd" points="7.67824028 10.1243675 9.06094211 11.5178475 12.2013314 7 16.6923077 14 5 14"></polygon><circle id="Oval-10" fill="#666666" fill-rule="evenodd" cx="7.23076923" cy="7.23076923" r="1.23076923"></circle></g></g></g></g></g></g></svg>
			</div>
		</draggable>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from 'vuedraggable'
export default {
	components: {
		draggable,
	},
	props: {
	  title: {
	    type: String, // String, Number, Boolean, Function, Object, Array
	    required: false,
	    default: 'Lorem ipsum dolor sit amet',
	  },
	  parrafo: {
	    type: String, // String, Number, Boolean, Function, Object, Array
	    required: false,
	    default: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
	  },
	  img1: {
	    type: String, // String, Number, Boolean, Function, Object, Array
	    required: false,
	    default: require('@/core/assets/img/no-image.png'),
	  },
	},
	name: 'widgetContents',
	data () {
		return {
			contentOpen: true,
			listSections : [],
			moldeSections : [
				{
					id: 1,
					divClass: 'section-custom section-bloque',
					container: 'container',
					columns: [
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail large',
							}],
							grids: 'col-6',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+' '+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-6',
							moreClass: '',
						},
					]
				},
				{
					id: 2,
					divClass: 'section-custom section-bloque',
					container: 'container',
					columns: [
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+' '+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-6',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+' '+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-6',
							moreClass: '',
						},
					]
				},
				{
					id: 3,
					divClass: 'section-custom section-bloque',
					container: 'container',
					columns: [
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							}],
							grids: 'col-6',
							moreClass: '',
						},
						{
							
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive large"/>',
								moreClass: 'img-thumbnail large',
							}],
							grids: 'col-6',
							moreClass: '',
						},
					]
				},
				{
					id: 4,
					divClass: 'section-custom section-bloque',
					container: 'container',
					columns: [
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+' '+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-4',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+' '+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-4',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+' '+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-4',
							moreClass: '',
						},
					]
				},
				{
					id: 5,
					divClass: 'section-custom section-bloque',
					container: 'container',
					columns: [
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							}],
							grids: 'col-3',
							moreClass: '',
						},
						{
							widgets: [
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-3',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							}],
							grids: 'col-3',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3><p>'+this.parrafo+'</p>',
								moreClass: 'textContent',
							}],
							grids: 'col-3',
							moreClass: '',
						},
					]
				},
				{
					id: 6,
					divClass: 'section-custom section-bloque',
					container: 'container',
					columns: [
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3>',
								moreClass: 'textContent',
							}],
							grids: 'col-3',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3>',
								moreClass: 'textContent',
							}],
							grids: 'col-3',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3>',
								moreClass: 'textContent',
							}],
							grids: 'col-3',
							moreClass: '',
						},
						{
							widgets: [{
								type: 'img', // texto, img
								htmlCode: '<img src="'+this.img1+'" alt="img" class="img-responsive"/>',
								moreClass: 'img-thumbnail',
							},
							{
								type: 'text', // texto, img
								htmlCode: '<h3>'+this.title+'</h3>',
								moreClass: 'textContent',
							}],
							grids: 'col-3',
							moreClass: '',
						},
					]
				},
			],
		}
	},
	created(){
		localStorage.setItem('listCloneSection', JSON.stringify(this.moldeSections))
		this.initBoxContent();
	},
	methods:{
		initBoxContent(){
			this.listSections=[];
			if(localStorage.getItem('listCloneSection')!=null){
				let list = JSON.parse(localStorage.getItem('listCloneSection'));
				for (let i in list) {
					if(list[i]){
						this.listSections.push({
							id: list[i].id,
							divClass: list[i].divClass+list[i].id,
							container: list[i].container,
							columns: list[i].columns,
						})
					}
				}
			}
			//window.console.log('initBoxContent');
		},
		log: function(evt) {
			window.console.log('log box-section', evt);
		},
		cloneSection(elem){
			let t = this;
			//window.console.log('cloneSection', elem);
			//debugger
			let itemClone = {};
			let listClone = [];
			let list = JSON.parse(localStorage.getItem('listCloneSection'));
			for (let i in list) {
				if(list[i].id == elem.id){
					itemClone = list[i];
				}
				if(list[i]){
					listClone.push(list[i])
				}
			}
			//t.initBoxContent();
			let clone = {
					divClass: itemClone.divClass,
					container: itemClone.container,
					columns: itemClone.columns,
				};
			t.$store.commit("ModApps/Sites/setcloseBarTools", 1);
			/*t.$store.commit("ModApps/Sites/setCloneBoxContent", clone);
			setTimeout(function(){
				t.$store.commit("ModApps/Sites/setCloneBoxContent", null);
				t.$store.commit("ModApps/Sites/setBoxContentCloneNewIndex", null);
				t.listSections=listClone;
			}, 1000);*/
			return clone;
		},
	},
	watch: {
		getRefreshBoxContent: function(){
			if(this.getRefreshBoxContent > 0){
				this.initBoxContent();
			}
		},
		getcloseBarTools: function(){
			console.log('getcloseBarTools', this.getcloseBarTools)
			if(this.getcloseBarTools==0){
				this.listSections=[];
			}
		},
	},
	computed: {
		...mapGetters("ModApps/Sites", { 
			getRefreshBoxContent: "getRefreshBoxContent",
			getcloseBarTools: "getcloseBarTools",
		}),

	}
}
</script>
<style lang="scss" scoped>

</style>
